import { MenuItem, Select } from '@mui/material';
import React, { useState } from 'react';

import { ChildInput } from '~/legacy-components/TopbarSurvey/types';

import { useSxStyles } from './useStyle';

type Props = {
  selectOnChange: (value: number) => void;
  selectDefaultValue: number;
  menuList: ChildInput[];
};

export const UnitSelect: React.FC<Props> = ({
  selectOnChange,
  selectDefaultValue,
  menuList,
}) => {
  const sxStyles = useSxStyles();
  const [selectValue, setSelectValue] = useState(selectDefaultValue);

  return (
    <Select
      value={selectValue}
      onChange={(e) => {
        setSelectValue(e.target.value as number);
        selectOnChange(e.target.value as number);
      }}
      sx={sxStyles.select}
      inputProps={{
        classes: {
          root: sxStyles.text,
          icon: sxStyles.select,
        },
      }}
    >
      {menuList.map((item) => (
        <MenuItem key={item.value} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
};
